import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../auth.service';
import { Router } from '@angular/router';
import { RoleService } from '../../../@core/services/role.service';
import { MasterService } from '../../../@core/services/master.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  isNotificationsOpen = false;
  isNotificationsLoading = false;
  notifications: any[] = [];
  notificationCount: number = 0;
  notificationTab: 'all' | 'unread' = 'all';
  userId: string = '';

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  // userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  userMenu = [
    { title: 'Profile', action: 'profile' },
    // { title: 'Log out', action: 'logout' }
  ];
  notificationMenu = [
    { title: 'No Notification'},
    // { title: 'Log out', action: 'logout' }
  ];
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: AuthService, 
              private router: Router,
              private roleService: RoleService,
              private masterService: MasterService,
              private toastrService: NbToastrService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.userId = sessionStorage.getItem('user_id') || '';

    if (this.userId) {
      this.loadNotifications();
    }

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      
      setTimeout(() => {
        this.sidebarService.collapse('menu-sidebar');
      }, 0); 
  }

  onMenuItemClick(event: any) {
    debugger;
    if (event?.title === 'Log out') {
      this.logout();
    } else if (event?.title === 'Profile') {
      this.goToProfile();
    }
  }

  // logout() {
  //   this.authService.logout();
  //   this.router.navigate(['/login']); // Redirect to the login page
  // }
  logout() {
    // Clear session or token (if applicable)
    this.roleService.logout();   
    sessionStorage.removeItem('userToken');
    localStorage.removeItem('userToken');
    // sessionStorage.removeItem('role');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('user_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    sessionStorage.clear();
    // Navigate to login page (or any other page)
    this.router.navigate(['/login']);
  }

  goToProfile() {
    this.router.navigate(['/profile']); // Redirect to the profile page
  }

  ngOnDestroy() {
    if (this.notificationObserver) {
      this.notificationObserver.disconnect();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  openHelpLink() {
  window.open('https://sourcebuddy.idamtat.in/', '_blank');
}
isChatOpen = false;
chatText = '';
messages: any[] = [];

users = ['Admin', 'Engineer', 'Manager'];
filteredUsers: string[] = [];
showMentions = false;

toggleChat() {
  this.isChatOpen = !this.isChatOpen;
}

  private notificationObserver: IntersectionObserver | null = null;

  toggleNotifications() {
    this.isNotificationsOpen = !this.isNotificationsOpen;

    if (this.isNotificationsOpen) {
      this.loadNotifications();
    } else {
      if (this.notificationObserver) {
        this.notificationObserver.disconnect();
      }
    }
  }

  loadNotifications() {
    if (!this.userId) {
      try {
        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        this.userId = sessionStorage.getItem('user_id') || userDetails?.user_id || userDetails?.userId || userDetails?.id || '';
      } catch (e) {
        this.userId = '';
      }
    }

    if (!this.userId) {
      this.notifications = [];
      this.notificationCount = 0;
      return;
    }

    this.isNotificationsLoading = true;
    this.masterService.fetchNotifications(this.userId).subscribe({
      next: (response: any) => {
        const rawList = this.extractNotifications(response);
        const readIds = this.getStoredReadNotificationIds();

        this.notifications = rawList.map(item => {
          const id = this.getNotificationId(item);
          const isRead = this.isNotificationRead(item) || (id ? readIds.has(String(id)) : false);
          return {
            ...item,
            read: isRead,
            is_read: isRead ? 1 : 0,
          };
        });

        this.updateNotificationCount();
        this.isNotificationsLoading = false;

        if (this.isNotificationsOpen) {
          setTimeout(() => this.setupIntersectionObserver(), 250);
        }
      },
      error: (error) => {
        console.error('Error fetching notifications:', error);
        this.notifications = [];
        this.notificationCount = 0;
        this.isNotificationsLoading = false;
      },
    });
  }

  setNotificationTab(tab: 'all' | 'unread') {
    this.notificationTab = tab;
    setTimeout(() => this.setupIntersectionObserver(), 250);
  }

  private setupIntersectionObserver() {
    if (typeof IntersectionObserver === 'undefined') return;

    if (this.notificationObserver) {
      this.notificationObserver.disconnect();
    }

    const container = document.querySelector('.notification-body');
    if (!container) return;

    this.notificationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const indexAttr = entry.target.getAttribute('data-index');
            if (indexAttr !== null) {
              const index = parseInt(indexAttr, 10);
              const notification = this.filteredNotifications[index];
              if (notification && !this.isNotificationRead(notification)) {
                this.markNotificationAsRead(notification);
              }
            }
          }
        });
      },
      {
        root: container,
        threshold: 0.5,
      }
    );

    const cards = container.querySelectorAll('.notif-card');
    cards.forEach((card) => this.notificationObserver?.observe(card));
  }

  isNotificationRead(notification: any): boolean {
    if (!notification) return false;
    return (
      notification.read === true ||
      notification.read === 1 ||
      notification.read === '1' ||
      notification.read === 'true' ||
      notification.is_read === true ||
      notification.is_read === 1 ||
      notification.is_read === '1' ||
      notification.is_read === 'true' ||
      notification.isRead === true ||
      notification.isRead === 1 ||
      notification.isRead === '1' ||
      notification.isRead === 'true' ||
      notification.status === 'read' ||
      notification.status === 'Read' ||
      notification.seen === true ||
      notification.seen === 1
    );
  }

  updateNotificationCount() {
    this.notificationCount = this.notifications.filter(item => !this.isNotificationRead(item)).length;
  }

  private getStoredReadNotificationIds(): Set<string> {
    try {
      const stored = sessionStorage.getItem(`read_notifications_${this.userId}`);
      if (stored) {
        return new Set(JSON.parse(stored));
      }
    } catch (e) {}
    return new Set<string>();
  }

  private storeReadNotificationId(notificationId: string | number) {
    if (!notificationId) return;
    try {
      const ids = this.getStoredReadNotificationIds();
      ids.add(String(notificationId));
      sessionStorage.setItem(`read_notifications_${this.userId}`, JSON.stringify(Array.from(ids)));
    } catch (e) {}
  }

  markNotificationAsRead(notification: any) {
    if (!notification || this.isNotificationRead(notification)) {
      return;
    }

    const notificationId = this.getNotificationId(notification);

    // Optimistically update local state immediately
    notification.read = true;
    notification.is_read = 1;
    notification.isRead = true;

    if (notificationId) {
      this.storeReadNotificationId(notificationId);
      this.masterService.markNotificationRead(notificationId).subscribe({
        next: () => {
          // Success from backend
        },
        error: (error) => {
          console.error('Error marking notification read on server:', error);
        },
      });
    }

    this.updateNotificationCount();
  }

  markAllAsRead() {
    const unread = this.notifications.filter(n => !this.isNotificationRead(n));
    if (!unread.length) return;

    unread.forEach(n => {
      n.read = true;
      n.is_read = 1;
      n.isRead = true;
      const id = this.getNotificationId(n);
      if (id) {
        this.storeReadNotificationId(id);
        this.masterService.markNotificationRead(id).subscribe({
          error: (err) => console.error('Error marking notification read:', err)
        });
      }
    });

    this.updateNotificationCount();
  }

  private getNotificationId(notification: any): number | string | null {
    return notification?.notification_id || notification?.id || notification?.notificationId || notification?._id || null;
  }

  private extractNotifications(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response?.data)) {
      return response.data;
    }

    if (Array.isArray(response?.notifications)) {
      return response.notifications;
    }

    if (Array.isArray(response?.result)) {
      return response.result;
    }

    return [];
  }

  get filteredNotifications(): any[] {
    if (this.notificationTab === 'unread') {
      return this.notifications.filter(n => !this.isNotificationRead(n));
    }
    return this.notifications;
  }

  getNotificationText(notification: any): string {
    return (
      notification?.message ||
      notification?.notification ||
      notification?.title ||
      notification?.description ||
      'Notification'
    );
  }

  getNotificationTime(notification: any): string {
    return (
      notification?.created_at ||
      notification?.createdAt ||
      notification?.date ||
      notification?.time ||
      ''
    );
  }

  formatNotificationTime(rawTime: string): string {
    if (!rawTime) return '';
    try {
      const date = new Date(rawTime);
      if (isNaN(date.getTime())) {
        return rawTime;
      }

      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHours = Math.floor(diffMin / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffMin < 1) return 'Just now';
      if (diffMin < 60) return `${diffMin}m ago`;
      if (diffHours < 24) return `${diffHours}h ago`;
      if (diffDays === 1) return 'Yesterday';
      if (diffDays < 7) return `${diffDays}d ago`;

      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    } catch (e) {
      return rawTime;
    }
  }

  getNotificationIcon(notification: any): string {
    const text = (this.getNotificationText(notification) || '').toLowerCase();
    if (text.includes('reject') || text.includes('error') || text.includes('alert')) {
      return 'alert-triangle-outline';
    }
    if (text.includes('approve') || text.includes('approved') || text.includes('success')) {
      return 'checkmark-circle-outline';
    }
    if (text.includes('submit') || text.includes('pending') || text.includes('review')) {
      return 'clock-outline';
    }
    if (text.includes('file') || text.includes('upload') || text.includes('document')) {
      return 'file-text-outline';
    }
    return 'bell-outline';
  }

  getNotificationIconClass(notification: any): string {
    const text = (this.getNotificationText(notification) || '').toLowerCase();
    if (text.includes('reject') || text.includes('error') || text.includes('alert')) {
      return 'icon-warning';
    }
    if (text.includes('approve') || text.includes('approved') || text.includes('success')) {
      return 'icon-success';
    }
    if (text.includes('submit') || text.includes('pending') || text.includes('review')) {
      return 'icon-info';
    }
    return 'icon-primary';
  }
selectedFile: File | null = null;

onFileUpload(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.selectedFile = file;
  }
}

cancelFile() {
  this.selectedFile = null;
}


sendMessage() {
  if (!this.chatText.trim() && !this.selectedFile) return;

  this.messages.push({
    user: 'You',
    text: this.chatText,
    file: this.selectedFile ? this.selectedFile.name : null,
  });

  this.chatText = '';
  this.selectedFile = null;
}

onMentionSearch() {
  const match = this.chatText.match(/@(\w*)$/);
  if (match) {
    const search = match[1].toLowerCase();
    this.filteredUsers = this.users.filter(u =>
      u.toLowerCase().includes(search)
    );
    this.showMentions = this.filteredUsers.length > 0;
  } else {
    this.showMentions = false;
  }
}

selectMention(user: string) {
  this.chatText = this.chatText.replace(/@\w*$/, `@${user} `);
  this.showMentions = false;
}
autoGrow(event: any) {
  const textarea = event.target as HTMLTextAreaElement;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}




}
